import { useUser } from '@clerk/clerk-react';

// UI-side admin gate — hides admin surfaces from non-admins. The server is
// authoritative (ADMIN_USER_ID + CRON_SECRET in api/admin/*); this is display
// gating only. Same check as V1's AdminPanel (src/components/admin.jsx).
const ADMIN_EMAILS = ['benjaminwolf36@gmail.com'];
const ADMIN_USER_ID = import.meta.env.VITE_ADMIN_USER_ID || '';

export function useIsAdmin() {
  const { user } = useUser();
  const email = user?.primaryEmailAddress?.emailAddress;
  return Boolean(
    (email && ADMIN_EMAILS.includes(email)) ||
    (ADMIN_USER_ID && user?.id === ADMIN_USER_ID)
  );
}
